import React from 'react';
import { StyledSvgIcon } from '../icon.styles';
import { customIconsPropTypes } from './customicons.propTypes';

const SpecialCheckmarkIcon = ({ fontSize, color, title, sx }) => (
  <StyledSvgIcon
    fontSize={fontSize}
    color={color}
    titleAccess={title}
    data-testid={title}
    aria-label={title}
    sx={sx}
  >
    <svg viewBox="0 0 87 87" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M43.5 87C19.4756 87 0 67.5244 0 43.5C0 19.4756 19.4756 0 43.5 0C44.9451 0 46.3738 0.0704677 47.7827 0.208154H87V43.5V47.6627H86.8034C84.708 69.7344 66.1203 87 43.5 87Z"
        fill="currentColor"
      />
      <path
        d="M61.6461 30.646L62.3541 31.354C62.7291 31.7291 62.9397 32.2377 62.9397 32.768C62.9397 33.2983 62.7291 33.8069 62.3541 34.182L39.4141 57.122C39.0391 57.4969 38.5304 57.7076 38.0001 57.7076C37.4698 57.7076 36.9612 57.4969 36.5861 57.122L26.6461 47.182C26.2712 46.8069 26.0605 46.2983 26.0605 45.768C26.0605 45.2377 26.2712 44.7291 26.6461 44.354L27.3541 43.646C27.7292 43.2711 28.2378 43.0604 28.7681 43.0604C29.2984 43.0604 29.8071 43.2711 30.1821 43.646L36.5861 50.05C36.9612 50.4249 37.4698 50.6356 38.0001 50.6356C38.5304 50.6356 39.0391 50.4249 39.4141 50.05L58.8181 30.646C59.1932 30.2711 59.7018 30.0604 60.2321 30.0604C60.7624 30.0604 61.2711 30.2711 61.6461 30.646Z"
        fill="white"
      />
    </svg>
  </StyledSvgIcon>
);
export default SpecialCheckmarkIcon;

SpecialCheckmarkIcon.propTypes = customIconsPropTypes;
